import * as React from 'react';
import { Link } from 'react-router-dom';

interface IProps {
    navigateTo: string;
    clickable: boolean;
    children?: any;
    className?: string;
    title?: string;
    style?: any;
    fullsize?: boolean;
}

const OrderListTableCell = (props: IProps) => {
    const fullsize = props.fullsize ? { width: "100%" } : {};
    
    if (props.clickable) {
        return (
            <td className={`${props.className ? props.className + ' ' : ''}clickable`} style={props.style}>
                <Link to={props.navigateTo} className="nolink" title={props.title ? props.title : ""} style={fullsize}>
                    {props.children}
                </Link>
            </td>
        );
    } else {
        return (
            <td style={props.style}>
                <span className="order-cell-padding">{props.children}</span>
            </td>
        );
    }
};

export default OrderListTableCell;
